import * as React from "react";

const SvgIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="svg293347"
    version="1.1"
    viewBox="0 0 357 65"
  >
    <g id="logo-group" fill="#FFF" transform="translate(-334.703 53.02)">
      <g id="logo-center" fill="#FFF">
        <g
          id="title"
          style={{
            lineHeight: "1",
            fontVariantLigatures: "none",
            textAlign: "center",
          }}
        >
          <path
            id="path293356"
            fill="#91D0E5"
            stroke="#91D0E5"
            d="M385.981-12.6c2.088-3.744 3.168-7.92 3.168-12.6 0-4.824-1.152-9.216-3.456-13.104-2.304-3.816-5.4-6.912-9.36-9.144-4.032-2.16-8.496-3.312-13.392-3.312-4.968 0-9.432 1.152-13.392 3.384-4.032 2.232-7.128 5.256-9.432 9.144s-3.384 8.28-3.384 13.032c0 4.68 1.008 8.856 3.096 12.6s4.968 6.768 8.712 9.072C352.213-1.224 356.39 0 361.07.288V9.72h3.744V.288c4.608-.288 8.712-1.512 12.456-3.816s6.624-5.328 8.712-9.072zm-10.728 6.192c-3.168 2.016-6.696 3.096-10.584 3.312v-12.96h-3.528v12.96c-3.96-.216-7.488-1.368-10.656-3.384s-5.616-4.608-7.416-7.92c-1.8-3.24-2.664-6.84-2.664-10.8 0-4.104.936-7.848 2.952-11.232 1.944-3.384 4.608-6.048 8.064-7.992s7.272-2.952 11.52-2.952c4.176 0 7.992 1.008 11.448 2.952 3.384 1.944 6.048 4.608 8.064 7.992 1.944 3.384 2.952 7.128 2.952 11.232 0 3.96-.936 7.56-2.736 10.872s-4.248 5.904-7.416 7.92z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
          <path
            id="path293358"
            fill="#A0D5E5"
            stroke="#A0D5E5"
            d="M406.71-5.184C410.238-1.44 415.206.36 421.614.36c6.336 0 11.304-1.8 14.904-5.544 3.528-3.672 5.328-9.072 5.328-16.2V-50.4h-3.672v28.872c0 6.192-1.44 10.872-4.248 13.896-2.88 3.096-6.912 4.608-12.24 4.608-5.4 0-9.504-1.512-12.312-4.608-2.88-3.024-4.248-7.704-4.248-13.896V-50.4h-3.672v29.016c0 7.128 1.728 12.528 5.256 16.2z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
          <path
            id="path293360"
            fill="#AFD9E5"
            stroke="#AFD9E5"
            d="M476.286-50.4h-3.672L449.43 0h3.96l21.024-46.368L495.51 0h3.96z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
          <path
            id="path293362"
            fill="#BEDEE5"
            stroke="#BEDEE5"
            d="M511.284-1.512C514.596-.216 518.124.36 521.868.36c3.96 0 7.344-.576 10.08-1.8 2.736-1.152 4.752-2.808 6.048-4.824s2.016-4.248 2.016-6.696c0-2.952-.792-5.328-2.376-7.056s-3.456-3.096-5.616-3.96c-2.232-.864-5.184-1.728-8.856-2.664-3.312-.792-5.976-1.584-7.848-2.304-1.944-.72-3.528-1.728-4.824-3.096q-1.944-1.944-1.944-5.4c0-2.952 1.152-5.4 3.6-7.272q3.564-2.808 10.584-2.808 3.456 0 7.128 1.08c2.448.72 4.68 1.8 6.696 3.168l1.368-2.952c-2.016-1.368-4.32-2.448-6.984-3.312-2.736-.792-5.472-1.224-8.208-1.224-4.032 0-7.344.648-10.008 1.8-2.664 1.224-4.608 2.88-5.904 4.896q-1.944 3.024-1.944 6.696c0 3.024.72 5.472 2.304 7.272a14.3 14.3 0 0 0 5.688 3.96c2.232.864 5.184 1.8 8.928 2.664 3.24.792 5.832 1.512 7.776 2.232 1.872.72 3.528 1.8 4.824 3.096q1.944 2.052 1.944 5.4 0 4.428-3.672 7.128c-2.448 1.872-6.12 2.736-10.872 2.736q-4.968 0-9.504-1.728c-3.024-1.152-5.4-2.736-7.128-4.608l-1.656 2.736q2.808 3.024 7.776 4.968z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
          <path
            id="path293364"
            fill="#CCE2E5"
            stroke="#CCE2E5"
            d="M570.927-50.4h-3.672L544.07 0h3.96l21.024-46.368L590.15 0h3.96z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
          <path
            id="path293366"
            fill="#DBE7E5"
            stroke="#DBE7E5"
            d="M629.829-17.64c3.744-1.08 6.696-2.952 8.712-5.688s3.096-6.048 3.096-10.08c0-5.256-1.8-9.432-5.4-12.456q-5.4-4.536-14.904-4.536H603.26v3.312h18.072c5.328 0 9.432 1.224 12.312 3.6 2.808 2.376 4.248 5.76 4.248 10.08 0 4.392-1.44 7.776-4.248 10.152-2.88 2.376-6.984 3.528-12.312 3.528H603.26V0h3.672v-16.488h14.4c1.44 0 3.096-.072 4.896-.36L638.253 0h4.176z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
          <path
            id="path293368"
            fill="#EAEBE5"
            stroke="#EAEBE5"
            d="M685.353 0h4.32l-19.368-26.064 18-24.336H684.2l-16.056 21.672L652.089-50.4h-4.32l18 24.408L646.4 0h4.32L668-23.328z"
            style={{
              lineHeight: "1",
              fontVariantLigatures: "none",
              textAlign: "center",
            }}
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default SvgIcon;
